import { VecoplanState } from "./_types";

export const DEFAULT_STATE: VecoplanState = {
    fetching: false,
    error: false,
    data: null,
    filteredData: [],
  }